import DataTable from "../../../components/Table";
import type { ColumnsType } from "antd/es/table";
import {
  Row,
  Col,
  Button,
  Space,
  Popconfirm,
  message,
  Tag,
  Switch,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import UserSearch from "./UserSearch";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchUser } from "../../../redux/slice/userSlice";
import AddUser from "./add";
import { callDeleteUser, callUpdateStatusUser } from "../../../config/api";
import ModalUser from "./edit";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE_DISPLAY } from "../../../utils/constants/timeFormat";
import ViewDetail from "./detail/ViewDetail";

interface DataType {
  key: React.Key;
  idTopic: string;
  idUser: string;
  description: string;
  image: string;
}
function ManageUser() {
  const [searchPagination, setSearchPagination] = useState(
    "current=1&pageSize=5"
  );
  const [searchData, setSearchData] = useState("");
  const [dataViewDetail, setDataViewDetail] = useState("");
  const [openViewDetail, setOpenViewDetail] = useState(false);
  const dispatch = useAppDispatch();
  const users = useAppSelector((state) => state.user);

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "_id",
      render: (text, record: any) => {
        return (
          <span
            style={{ color: "#4986ff", cursor: "pointer" }}
            onClick={() => {
              setDataViewDetail(record);
              setOpenViewDetail(true);
            }}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Date of birth",
      dataIndex: "date_of_birth",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "Gender",
      dataIndex: "gender",
      render: (text) => {
        let colorText = text?.length < 5 ? "blue" : "volcano";
        return <Tag color={colorText}>{text.toUpperCase()}</Tag>;
      },
    },
    {
      title: "Trạng thái hoạt động",
      dataIndex: "status",
      align: "center",
      render: (text, record: any) => {
        let textStatus = record?.status ? "khóa" : "mở khóa";
        return (
          <Popconfirm
            placement="top"
            title={`Xác nhận ${textStatus} tài khoản`}
            description={`Bạn có chắc chắn muốn ${textStatus} tài khoản này không ?`}
            onConfirm={() => confirmChange(record, onChangeStatus)}
            okText="Xác nhận"
            cancelText="Hủy">
            <Switch checked={record.status} />
          </Popconfirm>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      render: (_, record: any) => (
        <Space size="middle">
          <ModalUser record={record} handleFetchUser={handleFetchUser} />
          <Popconfirm
            placement="leftTop"
            title={"Xác nhận xóa user"}
            description={"Bạn có chắc chắn muốn xóa user này ?"}
            onConfirm={() => handleDeleteUser(record._id)}
            okText="Xác nhận"
            cancelText="Hủy">
            <Button type="primary" danger ghost>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  let query = `${searchPagination}${searchData}&sort=-updatedAt`;
  const handleDeleteUser = async (id: string) => {
    const result = await callDeleteUser(id);
    if (result.statusCode === 200) {
      handleFetchUser();
      message.success("delete success!");
    } else {
      message.error("delete failed!");
    }
  };

  const onChangeStatus = async (record: any) => {
    // Thêm logic xử lý khi thay đổi trạng thái switch
    const valueStatus = { userId: record?._id, status: !record?.status };
    const res = await callUpdateStatusUser(valueStatus);
    if (res.statusCode === 200) {
      handleFetchUser();
      message.success(`Cập nhật trạng thái thành công`);
    }
  };

  const confirmChange = (record: any, callback: any) => {
    // Gọi hàm callback khi người dùng xác nhận thay đổi
    callback(record);
  };

  const handleFetchUser = () => {
    dispatch(fetchUser({ query }));
  };
  useEffect(() => {
    handleFetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleModalCreate = (): JSX.Element => {
    return (
      <>
        <AddUser handleFetchUser={handleFetchUser} />
      </>
    );
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <UserSearch handleSearch={setSearchData} />
        </Col>
      </Row>
      <DataTable
        columns={columns}
        data={users?.result}
        total={users?.meta.total}
        loading={users.isFetching}
        modalAdd={handleModalCreate}
        name="Users"
        setSearchPagination={setSearchPagination}
        // onChange={onChange}
      />
      <ViewDetail
        openViewDetail={openViewDetail}
        dataViewDetail={dataViewDetail}
        setOpenViewDetail={setOpenViewDetail}
      />
    </>
  );
}

export default ManageUser;
